import { useContent } from '@/content';
import { Editable } from '@/content/design';

export default function ContactSection() {
  const c = useContent();
  const mailSubject = 'Anfrage über Gesichtszauber – Behandlung / Termin';
  const mailBody = `Hallo Sonja,

ich interessiere mich für:

– Ihre Behandlung / Beratung: [z. B. Microneedling, Mesoporation, Fruchtsäurepeeling ...]
– Mein Wunschtermin: [bitte eintragen]

Zu mir: [kurze Info zu Ihrem Anliegen oder Hauttyp]

Mit freundlichen Grüßen
[Ihr Name]`;

  const telHref = `tel:${c.contact.phone.replace(/[^+\d]/g, '')}`;
  const mapsQuery = encodeURIComponent(c.contact.address);
  const contactMailto = `mailto:${c.contact.email}?subject=${encodeURIComponent(mailSubject)}&body=${encodeURIComponent(mailBody)}`;
  const shareMailto = `mailto:?subject=${encodeURIComponent('Gesichtszauber – Sonja Karmann')}&body=${encodeURIComponent(`Schau dir diese tolle Seite an: ${window.location.href}`)}`;

  return (
    <section id="kontakt" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="animate-on-scroll">
            <Editable as="p" id="contact.eyebrow" label="Kontakt – Kleine Überschrift" className="text-xs tracking-[0.3em] uppercase text-champagne-500 font-medium mb-3">
              {c.contact.eyebrow}
            </Editable>
            <Editable as="h2" id="contact.title" label="Kontakt – Titel" className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-4">
              {c.contact.title}
            </Editable>
            <Editable as="p" id="contact.subtitle" label="Kontakt – Untertitel" className="text-gray-500 text-sm md:text-base leading-relaxed mb-10">
              {c.contact.subtitle}
            </Editable>
          </div>

          <div className="animate-on-scroll-scale delay-200">
            <div className="bg-gradient-to-br from-blush-50 to-champagne-50 rounded-2xl p-8 md:p-12 border border-blush-100">
              <div className="w-16 h-16 mx-auto rounded-full bg-white shadow-sm flex items-center justify-center mb-6">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-send-line text-champagne-500 text-2xl"></i>
                </div>
              </div>

              <Editable as="p" id="contact.boxLabel" label="Kontakt – Box-Text" className="text-gray-500 text-sm mb-2">{c.contact.boxLabel}</Editable>
              <a
                href={contactMailto}
                className="font-display text-xl md:text-2xl text-gray-800 hover:text-champagne-500 transition-colors inline-flex items-center gap-3"
              >
                {c.contact.email}
              </a>

              <div className="mt-6 flex flex-col items-center gap-4">
                <a
                  href={telHref}
                  className="inline-flex items-center gap-2.5 text-gray-700 hover:text-champagne-500 transition-colors group"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white shadow-sm group-hover:shadow transition-all">
                    <i className="ri-phone-line text-champagne-500"></i>
                  </div>
                  <span className="text-sm font-medium">{c.contact.phone}</span>
                </a>

                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${mapsQuery}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-2.5 text-gray-700 hover:text-champagne-500 transition-colors group"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white shadow-sm group-hover:shadow transition-all">
                    <i className="ri-map-pin-line text-champagne-500"></i>
                  </div>
                  <span className="text-sm font-medium">{c.contact.address}</span>
                </a>
              </div>

              <div className="mt-8 rounded-xl overflow-hidden border border-blush-100 shadow-sm">
                <iframe
                  src={`https://maps.google.com/maps?q=${mapsQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                  width="100%"
                  height="280"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Kosmetikstudio Gesichtszauber – Standort"
                  className="w-full"
                ></iframe>
              </div>

              <div className="mt-8 pt-6 border-t border-blush-100/50">
                <p className="text-xs text-gray-400 mb-4">{c.contact.shareLabel}</p>
                <div className="flex items-center justify-center gap-3">
                  <a
                    href={shareMailto}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-sm text-gray-400 hover:text-champagne-500 hover:shadow transition-all"
                    aria-label="Per E-Mail teilen"
                  >
                    <i className="ri-mail-line"></i>
                  </a>
                  <button
                    onClick={() => {
                      if (navigator.clipboard) {
                        navigator.clipboard.writeText(window.location.href);
                        alert('Link kopiert!');
                      }
                    }}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-sm text-gray-400 hover:text-champagne-500 hover:shadow transition-all"
                    aria-label="Link kopieren"
                  >
                    <i className="ri-link"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}